import React, {useState, useRef, useEffect, forwardRef, useImperativeHandle} from 'react';

import {isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet} from 'react-device-detect';

// 1. Import the functions
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock-upgrade'';
  
import * as constants from '../constants';

import {getLocalStorage, setLocalStorage} from '../hooks/localStorageWithTTL';
import {openAppOrStore} from '../hooks/openAppOrStore';

import { CommonScrollUtils } from "./CommonScrollUtils";
import closeIcon from '../assets/icon/close-button.png';

// window.onerror = function(message, url, line, col, errorObj) {
//   //console.log(`${message}\n${url}, ${line}:${col}`);
//   //console.log(errorObj);
// };

const CommonComponent = (props) => {
//const CommonComponent = forwardRef((props, ref) => {

    // const scrollYiOSRef = useRef(0);

    // useImperativeHandle(ref, () => ({
    //     // doSomething: (msg) => {
    //     //     alert(`CommonComponent function called: ${msg}`);
    //     // }
    //     Common_lockScrollNew: () => {
    //         console.log("CommonComponent-Common_lockScrollNew ");
    //         if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
    //         {
    //             // document.body.style.overflow = "hidden";
    //             // document.body.style.position = "fixed";
    //             // document.body.style.width = "100%";

    //             //scrollYiOS = window.scrollY; // save current scroll
    //             scrollYiOSRef.current = window.scrollY;
    //             document.body.style.position = "fixed";
    //             //document.body.style.top = `-${scrollYiOS}px`;
    //             document.body.style.top = `-${scrollYiOSRef.current}px`;
    //             document.body.style.left = "0";
    //             document.body.style.right = "0";
    //             document.body.style.width = "100%";            
    //         }            
    //     },

    //     Common_unlockScrollNew: () => {
    //         console.log("CommonComponent-Common_unlockScrollNew ");
    //         if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
    //         {
    //             // document.body.style.overflow = "";
    //             // document.body.style.position = "";
    //             // document.body.style.width = "";

    //             document.body.style.position = "";
    //             document.body.style.top = "";
    //             document.body.style.left = "";
    //             document.body.style.right = "";
    //             document.body.style.width = "";
    //             //window.scrollTo(0, scrollYiOS); // restore scroll  
    //             window.scrollTo(0, scrollYiOSRef.current);          
    //         }           
    //     },

    //     Common_preventTouchScroll: (e) => {
    //         console.log("CommonComponent-Common_preventTouchScroll ");
    //         if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
    //         {
    //             e.preventDefault();
    //             //preventTouchScroll(e);
    //         }         
    //     },
        
    //     Common_enableTouchBlock: () => {
    //         console.log("CommonComponent-Common_enableTouchBlock ");
    //         if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
    //         {
    //             document.body.addEventListener("touchmove", preventTouchScroll, { passive: false });
    //         }         
    //     },          
        
    //     Common_disableTouchBlock: () => {
    //         console.log("CommonComponent-Common_disableTouchBlock ");
    //         if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
    //         {
    //             document.body.removeEventListener("touchmove", preventTouchScroll);
    //         }         
    //     },        
        
    // }));   

    const initialized = useRef(false);

    // const {postData, postId, onSetModalBox2} = props;

    // p_handleChildClick_lockScrollNew={handleChildClick_lockScrollNew}
    // p_handleChildClick_unlockScrollNew={handleChildClick_unlockScrollNew}
    // p_handleChildClick_preventTouchScroll={handleChildClick_preventTouchScroll}
    // p_handleChildClick_enableTouchBlock={handleChildClick_enableTouchBlock}
    // p_handleChildClick_disableTouchBlock={handleChildClick_disableTouchBlock}    

    const {postCreatorInfo, sendDataToParent, 
        // p_handleChildClick_lockScrollNew, 
        // p_handleChildClick_unlockScrollNew,
        // p_handleChildClick_preventTouchScroll,
        // p_handleChildClick_enableTouchBlock,
        // p_handleChildClick_disableTouchBlock
    } = props;

    const dontDismissModelHide = useRef(true);
    const timeoutDontDismissModel = 30 * 1000; // in milliseconds (30 Seconds)

    const [dontMissModel, setDontMissModel] = useState(true);    
    const [fullProfileInAppModal, setFullProfileInAppModal] = useState(true);
    const postCountMaxModelTimes = 3;    
    const [fullProfileInAppModalClose, setFullProfileInAppModalClose] = useState(0);

    let scrollPosition = 0;

    const optionsBodyScrollOptions = {
        reserveScrollBarGap: true,
    };

    const lockScroll = (targetElement) => {
        // console.log('CommonComponent-lockScroll:targetElement:',targetElement);
        // console.log('CommonComponent-lockScroll:isIOS:',isIOS);
        scrollPosition = window.scrollY;
        if (targetElement) {
            if( ! isIOS){
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = "hidden";
            }            
            disableBodyScroll(targetElement, optionsBodyScrollOptions);
        }
        setLocalStorage('model_popup_scrollPosition', scrollPosition, 15 * 60);
        //console.log('CommonComponent-lockScroll:scrollPosition:',scrollPosition);
    };
    
    const unlockScroll = (targetElement) => {
        // console.log('CommonComponent-unlockScroll:targetElement:',targetElement);
        // console.log('CommonComponent-unlockScroll:isIOS:',isIOS);
        if (targetElement) {
            if( ! isIOS){
                document.body.style.overflow = 'unset';
                document.documentElement.style.overflow = "scroll";
            }
            enableBodyScroll(targetElement);
        }
        var _scrollPosition = getLocalStorage('model_popup_scrollPosition');
        scrollPosition = _scrollPosition;
        //console.log('CommonComponent-unlockScroll:_scrollPosition:',_scrollPosition);
        // if(isIOS)
        //     window.scrollTo(0, _scrollPosition);
    }; 
    
    
    /************************************** Start Fix iOS Popup scroll in iphone */

    // const commonRef = useRef();

    // const callCommonFromParent = () => {
    //     if (commonRef.current) {
    //         //commonRef.current.doSomething("Called from Parent!");
    //     }
    // };    

    // p_handleChildClick_lockScrollNew, 
    // p_handleChildClick_unlockScrollNew,
    // p_handleChildClick_preventTouchScroll,
    // p_handleChildClick_enableTouchBlock,
    // p_handleChildClick_disableTouchBlock


    //let scrollYiOS = 0;

    const lockScrollNew = () => {
        //console.log("CommonComponent-lockScrollNew ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     // document.body.style.overflow = "hidden";
        //     // document.body.style.position = "fixed";
        //     // document.body.style.width = "100%";

        //     scrollYiOS = window.scrollY; // save current scroll
        //     document.body.style.position = "fixed";
        //     document.body.style.top = `-${scrollYiOS}px`;
        //     document.body.style.left = "0";
        //     document.body.style.right = "0";
        //     document.body.style.width = "100%";            
        // }

        // if (ref && ref.current) {
        //     //ref.current.doSomething("Called from CommonComponent button!");
        //     console.log("CommonComponent-lockScrollNew Called from CommonComponent button");
        //     ref.current.Common_lockScrollNew();
        // } else {
        //     //alert("Button clicked inside CommonComponent!");
        //     console.log("CommonComponent-lockScrollNew Button clicked inside CommonComponent");
        // }

        //p_handleChildClick_lockScrollNew();

        CommonScrollUtils.lockScroll();
    };

    const unlockScrollNew = () => {
        //console.log("CommonComponent-unlockScrollNew ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     // document.body.style.overflow = "";
        //     // document.body.style.position = "";
        //     // document.body.style.width = "";

        //     document.body.style.position = "";
        //     document.body.style.top = "";
        //     document.body.style.left = "";
        //     document.body.style.right = "";
        //     document.body.style.width = "";
        //     window.scrollTo(0, scrollYiOS); // restore scroll            
        // }

        // if (ref && ref.current) {
        //     //ref.current.doSomething("Called from CommonComponent button!");
        //     console.log("CommonComponent-unlockScrollNew Called from CommonComponent button");
        //     ref.current.Common_unlockScrollNew();
        // } else {
        //     //alert("Button clicked inside CommonComponent!");
        //     console.log("CommonComponent-unlockScrollNew Button clicked inside CommonComponent");
        // }        
        //p_handleChildClick_unlockScrollNew();
        CommonScrollUtils.unlockScroll();
    };  
    
    const preventTouchScroll = (e) => {
        //console.log("CommonComponent-preventTouchScroll ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     e.preventDefault();
        // }

        // if (ref && ref.current) {
        //     //ref.current.doSomething("Called from CommonComponent button!");
        //     console.log("CommonComponent-preventTouchScroll Called from CommonComponent button");
        //     ref.current.Common_preventTouchScroll();
        // } else {
        //     //alert("Button clicked inside CommonComponent!");
        //     console.log("CommonComponent-preventTouchScroll Button clicked inside CommonComponent");
        // } 

        //p_handleChildClick_preventTouchScroll(e);

        CommonScrollUtils.preventTouchScroll(e);
    };

    const enableTouchBlock = () => {
        console.log("CommonComponent-enableTouchBlock ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     document.body.addEventListener("touchmove", preventTouchScroll, { passive: false });
        // }
        // if (ref && ref.current) {
        //     //ref.current.doSomething("Called from CommonComponent button!");
        //     console.log("CommonComponent-enableTouchBlock Called from CommonComponent button");
        //     ref.current.Common_enableTouchBlock();
        // } else {
        //     //alert("Button clicked inside CommonComponent!");
        //     console.log("CommonComponent-enableTouchBlock Button clicked inside CommonComponent");
        // }         
        //p_handleChildClick_enableTouchBlock();

        CommonScrollUtils.enableTouchBlock();
    };

    const disableTouchBlock = () => {
        //console.log("CommonComponent-disableTouchBlock ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     document.body.removeEventListener("touchmove", preventTouchScroll);
        // }
        // if (ref && ref.current) {
        //     //ref.current.doSomething("Called from CommonComponent button!");
        //     console.log("CommonComponent-disableTouchBlock Called from CommonComponent button");
        //     ref.current.Common_disableTouchBlock();
        // } else {
        //     //alert("Button clicked inside CommonComponent!");
        //     console.log("CommonComponent-disableTouchBlock Button clicked inside CommonComponent");
        // }         
        //p_handleChildClick_disableTouchBlock();
        CommonScrollUtils.disableTouchBlock();
    };    

    /************************************** End Fix iOS Popup scroll in iphone */    

    // useEffect(() => {
    //     //console.log('Component did mount');
    
    //     // Perform any setup or side-effects

    //     return () => {
    //         //console.log('Component will unmount');
    //         // Perform cleanup here (e.g., removing event listeners)

    //         // 5. Useful if we have called disableBodyScroll for multiple target elements,
    //         // and we just want a kill-switch to undo all that.
    //         // OR useful for if the `hideTargetElement()` function got circumvented eg. visitor
    //         // clicks a link which takes him/her to a different page within the app.
    //         clearAllBodyScrollLocks();

    //     };
    // }, []); // Empty array ensures this effect runs only on mount/unmount

    function handleDataToParent(data) {
        dontDismissModelHide.current = data;
        sendDataToParent(data);
    }

    useEffect(() => {
        if (!initialized.current) 
        {
            initialized.current = true; 
            initialized.counter = 1;  

        }
        else
        {
            initialized.counter += 1;
        }

        // Lock scroll when modal is visible
        document.addEventListener('touchmove', function(e) {

            //console.log("touchmove-staticBackdropBox", document.getElementById("staticBackdropBox"));

            //if ($('.modal.show').length) {
            if (document.getElementById("staticBackdropBox")?.style?.display=="block") {
                e.preventDefault(); // stops background scroll
            }
        }, { passive: false });

    }, []);

    const getTheExplurgerAppNow = () => {
        //console.log("CommonComponent-getTheExplurgerAppNow ");
        //isMobile, isAndroid, isIOS, isWinPhone
        //console.log(isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet);
        // var url = constants.APP_WEBSITE_URL;
        // if((isMobile || isTablet) && isAndroid)
        // {
        //     url = constants.APP_GOOGLE_PLAY_URL;
        // }
        // else if((isMobile || isTablet) && isIOS)
        // {
        //     url = constants.APP_APPLE_APP_STORE_URL;
        // }                
        // window.open(url);

        openAppOrStore();
    }    


    const BottomModalOpen = (display) => {
        //console.log("CommonComponent-BottomModalOpen ", display);
        var modelBox = document.getElementById('staticBackdropBox');
        modelBox.style.display = display;
        var model = document.getElementById('staticBackdrop');
        //console.log("BottomModalOpen ", model, display);
        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll
            //disableBodyScroll(modelBox); 
            //lockScroll(modelBox);    
            
            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();            
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox);

            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();            
        }
    }

    const modalClose = () => {
        //console.log("CommonComponent-modalClose ");
        var modelBox = document.getElementById('staticBackdropBox');
        modelBox.style.display = 'none';
        var model = document.getElementById('staticBackdrop'); 
        if (model) {
            model.style.display = 'none';

            // bottomModelHide.current = false;
            // setTimeout(()=>{
            //     bottomModelHide.current = true;
            // },timeoutBottomModel);

            setFullProfileInAppModalClose((fullProfileInAppModalClose + 1));

            //console.log('fullProfileInAppModalClose-', fullProfileInAppModalClose, postCountMaxModelTimes);           
        }
        document.body.style.overflow = 'unset';
        document.documentElement.style.overflow = "scroll";
        //document.body.classList.remove("modal-open");

        // 5. Re-enable body scroll
        //console.log(modelBox);
        //enableBodyScroll(modelBox);
        //clearAllBodyScrollLocks();
        //unlockScroll(modelBox);

        // iOS Popup scroll fix - When popup closes:
        unlockScrollNew();
        disableTouchBlock();

        // let element = document.querySelector("a.notNow");
        // if (element) {
        //     element.textContent = "Not Now"; // sets the text inside the <a> tag
        // }
    }

    const modalCloseContinue = () => {
        //console.log("CommonComponent-modalCloseContinue ");
        var modelBox = document.getElementById('staticContinueWebsiteBox');
        //modelBox.style.display = 'none';
        var model = document.getElementById('staticContinueWebsite'); 
        // if (model) {
        //     model.style.display = 'none';           
        // }
        document.body.style.overflow = 'unset';
        document.documentElement.style.overflow = "scroll";
        //document.body.classList.remove("modal-open");

        // 5. Re-enable body scroll
        //console.log(modelBox);
        //enableBodyScroll(modelBox);
        //clearAllBodyScrollLocks();
        //unlockScroll(modelBox);

        // iOS Popup scroll fix - When popup closes:
        unlockScrollNew();
        disableTouchBlock();

        const modalDialog = model.querySelector('.modal-dialog');

        const onTransitionEnd = (e) => {
            if (e.target === modalDialog) {
                modalDialog.removeEventListener('transitionend', onTransitionEnd);
                if (modelBox) {
                    modelBox.style.display = 'none';                
                }
                if (model) {
                    model.style.display = 'none';                
                }
                // header.sticky_top_header
                // z-index: 1000;
                const sticky_top_header = document.querySelector('header.sticky_top_header');
                sticky_top_header.style.zIndex = '1000';                
            }
        };
        
        modalDialog.addEventListener('transitionend', onTransitionEnd);


        modalDialog.style.transform = 'translateY(100vh)';        
    }    

    // modalCloseContinue

    const dontDismissModalClose = () => {
        //console.log("CommonComponent-dontDismissModalClose ");
        var modelBox = document.getElementById('dontMissModalBox');
        modelBox.style.display = 'none';
        var model = document.getElementById('dontMissModal');
        if (model) {
            model.style.display = 'none';

            //dontDismissModelHide.current = false;
            handleDataToParent(false);

            setTimeout(()=>{
                //dontDismissModelHide.current = true;
                handleDataToParent(true);
            },timeoutDontDismissModel);
        }
        document.body.style.overflow = 'unset';
        document.documentElement.style.overflow = "scroll";
        //document.body.classList.remove("modal-open");

        // 5. Re-enable body scroll
        //console.log(modelBox);
        //enableBodyScroll(modelBox);
        //clearAllBodyScrollLocks();
        //unlockScroll(modelBox);

        // iOS Popup scroll fix - When popup closes:
        unlockScrollNew();
        disableTouchBlock(); 
        
        // let element = document.querySelector("a.notNow");
        // if (element) {
        //     element.textContent = "Not Now"; // sets the text inside the <a> tag
        // }        
    } 
    
    const clickContinueModalOpen = () => {
        //console.log("CommonComponent-clickCenterModalOpen ");
        ContinueModalOpen("flex");
    }

    const ContinueModalOpen = (display) => {      
        //console.log("CommonComponent-ContinueModalOpen ", display);
        var modelBox = document.getElementById('staticContinueWebsiteBox');
        modelBox.style.display = display;
        var model = document.getElementById('staticContinueWebsite');
        //console.log("ContinueModalOpen ", model, display);

        const modalDialog = model.querySelector('.modal-dialog');

        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);    

            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();

            requestAnimationFrame(() => {
                modalDialog.style.transform = 'translateY(0)';
            });

            // header.sticky_top_header
            // z-index: 1000;
            const sticky_top_header = document.querySelector('header.sticky_top_header');
            sticky_top_header.style.zIndex = '0';             
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox);

            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();

            modalDialog.style.transform = 'translateY(100vh)';

            // header.sticky_top_header
            // z-index: 1000;
            const sticky_top_header = document.querySelector('header.sticky_top_header');
            sticky_top_header.style.zIndex = '1000';             
        }        
    }    

    const clickCenterModalOpen = () => {
        //console.log("CommonComponent-clickCenterModalOpen ");
        CenterModalOpen("flex");
    }

    const CenterModalOpen = (display) => {      
        //console.log("CommonComponent-CenterModalOpen ", display);
        var modelBox = document.getElementById('dontMissModalBox');
        modelBox.style.display = display;
        var model = document.getElementById('dontMissModal');
        //console.log("CenterModalOpen ", model, display);
        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);    

            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox);

            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();

        }        
    }   
    
    const seeTheFullProfileInAppModal = () => {
        return (<>
            <div id="staticBackdropBox" style={{display: 'none'}} >
                <div className="fade modal-backdrop show"></div>
                <div className="modal staticBackdrop" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog seeTheFullProfileInAppModalDialog midSeeMorePopup">
                        <div className="modal-content">
                            <div className="modal-body text-center">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="col-sm-12 img_data_modal modalUserProfile">
                                            <img className="circle_profile_small" 
                                                src={postCreatorInfo.Creater_ProfilePic} 
                                                alt="image_profile"></img>                                                
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <p className='bottom-modelTitle want-to-engage-txt'>See more from <b>{postCreatorInfo.Creater_Name}</b> on Explurger</p>
                                        <p className='bottom-modelDesc open-the-app-to-connect'>Keep up with what's new being shared.</p>
                                        <button className='btn getTheApp mb-3 max-width-80-per' onClick={getTheExplurgerAppNow}>Open in App</button>
                                        <div className="mb-3">{fullProfileInAppModal ? <a className='notNow' id="hideNotNowInEndPopup" onClick={modalClose}>Not Now</a> : <div>&nbsp;</div>}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }

    // Continue on the website
    const continueWebsiteModal = () => {
        return (<>
            <div id="staticContinueWebsiteBox" style={{display: 'none'}} >
                <div className="fade modal-backdrop show"></div>
                <div className="modal staticContinueWebsite fade" id="staticContinueWebsite" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticContinueWebsiteLabel" aria-hidden="true">
                    <div className="modal-dialog seeTheFullProfileInAppModalDialog showInBottomContinueWebsite newChange">
                        <div className="modal-content">
                            <img src={closeIcon} alt="close" className="closeBtnModal closeIconStyle" onClick={modalCloseContinue} />
                        
                            <div className="modal-body text-center">
                                <div className="row">

                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className="col-sm-12 img_data_modal modalUserProfile modalUserProfileContinue">
                                                <img className="circle_profile_small circle_profile_small_continue" 
                                                    src={postCreatorInfo.Creater_ProfilePic} 
                                                    alt="image_profile"></img>                                                
                                            </div>
                                        </div>

                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <h3 className='bottom-modelTitle txt-continue-head mb-1'>See full profile in the app</h3>
                                            <p className='bottom-modelDesc txt-continue-desc'>Enjoy photos, videos & more from <b>{postCreatorInfo.Creater_Name}</b></p>
                                            <button className='btn getTheApp openInApp mb-3' onClick={getTheExplurgerAppNow}>Open in App</button>
                                            {<div><a className='notNow' onClick={modalCloseContinue}>Continue on the Web</a><br></br><br></br></div>}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }    

    const dontMissModal = () => {
        return (<>
            <div id="dontMissModalBox" style={{display: 'none'}} >
                <div className="fade modal-backdrop show"></div>
                <div className="modal dontMissModal" id="dontMissModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered dontMissModalDialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                {/* <button type="button" className="btn-close" aria-label="Close" onClick={dontDismissModalClose}></button> */}
                                {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={dontDismissModalClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button> */}
                            </div>
                            <div className="modal-body text-center">
                                <div className="row">

                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <div className="col-sm-12 img_data_modal modalUserProfile">
                                                <img className="circle_profile_small" 
                                                    src={postCreatorInfo.Creater_ProfilePic} 
                                                    alt="image_profile"></img>                                                
                                            </div>
                                        </div> 

                                        
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <p className='bottom-modelTitle want-to-engage-txt'>Want to engage with <b>{postCreatorInfo.Creater_Name}'s</b> post?</p>
                                            <p className='bottom-modelDesc open-the-app-to-connect'>Open the app to connect, react and explore more</p>
                                            <button className='btn getTheAppCenetr' onClick={getTheExplurgerAppNow}>Open in App</button>
                                            <div className="mb-3">
                                                {dontMissModel && <a className='notNow' id="hideNotNowOnDontMissModel" onClick={dontDismissModalClose}>Not Now</a>}
                                            </div>
                                        </div>                               
                                       


                                {/* 
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <p className='modelTitle'>
                                            Want to engage with <b>{postCreatorInfo.Creater_Name}'s</b> post?
                                        </p>
                                        <p className='modelDesc'> Open the app to connect, react and explore more. <br></br></p>
                                        <button className='btn getTheAppCenetr' onClick={getTheExplurgerAppNow}>Open in Explurger App</button>
                                        <br></br>
                                        <br></br>
                                        {dontMissModel && <a className='notNow' onClick={dontDismissModalClose}>Not Now</a>}
                                        <br></br>
                                        <br></br>
                                    </div>                            
                                </div> 
                                */}

                                                                
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>                    
        </>)
    }     


    return (<> 
        {dontMissModal()}
        {seeTheFullProfileInAppModal()} 
        {continueWebsiteModal()}    
    </>);

}

export default CommonComponent;